<template>
  <div>
    <div class="tw-flex tw-justify-center tw-items-center">
      <button class="base-btn tw-py-1" @click="dialog = true">
        {{
          btnName ? btnName : $t(`BUTTONS.${this.editable ? "edit" : "create"}`)
        }}
      </button>
    </div>

    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      :width="width"
      :max-width="maxWidth"
    >
      <div
        class="tw-bg-white tw-justify-center tw-flex tw-p-5 tw-rounded-xl tw-min-h-[250px]"
      >
        <ValidationObserver
          class="tw-flex tw-flex-col tw-w-full"
          ref="appForm"
          @submit.prevent="submit"
        >
          <div class="md:tw-grid md:tw-grid-cols-2 tw-gap-3 tw-mb-3">
            <template v-for="(data, index) in formData">
              <div
                :key="index"
                :class="data.fullWidth ? 'md:tw-col-span-2' : ''"
              >
                <component
                  :is="data.inputType"
                  :name="data.name"
                  v-model="data.modelValue"
                  :placeholder="data.placeholder"
                  :label="data.label"
                  :rules="data.rules"
                  :type="data.type"
                  :data="data"
                  :modalName="data.modalName"
                  :api-url="data.apiUrl"
                  @imageDeleted="imageDeleted($event, index)"
                ></component>
              </div>
            </template>
            <slot />
          </div>

          <div
            class="tw-flex tw-justify-center tw-items-center tw-gap-2 tw-mt-auto"
          >
            <button
              type="submit"
              @click="submit"
              class="base-btn tw-py-1"
              :disabled="btnLoading"
            >
              {{ $t(`BUTTONS.${this.editable ? "edit" : "create"}`) }}
            </button>
            <button
              class="base-btn-white tw-py-1"
              @click="close"
              :disabled="btnLoading"
            >
              {{ $t("BUTTONS.close") }}
            </button>
          </div>
          <!-- <app-input name="title" v-model="title" /> -->
        </ValidationObserver>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    formData: {
      required: true,
    },
    classes: {
      required: false,
    },
    width: {
      required: false,
    },
    maxWidth: {
      required: false,
    },
    editable: {
      required: false,
    },
    loading: {
      required: false,
    },
    closeModal: {
      required: false,
    },
    btnName: {
      required: false,
    },
  },
  data() {
    return {
      dialog: false,
      form_fields: [],
      btnLoading: false,
    };
  },
  methods: {
    submit() {
      this.$refs.appForm.validate().then((valid) => {
        if (valid) this.$emit("submit", this.form_fields);
      });
    },
    imageDeleted(index) {
      this.$emit("imageDeleted", index);
    },
    close() {
      console.log(this.$refs.appForm);
      this.$refs.appForm.reset();
      this.dialog = false;
    },
  },
  mounted() {
    this.form_fields = this.formData;
  },
  watch: {
    loading(newVal) {
      this.btnLoading = newVal;
    },
    closeModal(newVal) {
      if (newVal) {
        this.close();
      }
    },
  },
};
</script>
